import React from "react";
import "./Flights1.css";
import img4 from "../images/img4.jpg";

const Flights1 = () => {
  return (
    <div className="flights1">
      <h2>Discovery Flight</h2>
      <div className="flights1-content">
        <div className="flights1-content1">
          <h3>FOR WHO?</h3>
          <p>
            Introduction to paragliding from 3 years old and with no age limits!
            120 kg maximum weight.
          </p>
          <h3>WHEN?</h3>
          <p>In the morning from 9:00am to 6:00pm</p>
          <h3>KIND OF FLIGHT?</h3>
          <p>
            A calm flight so you can discover the feeling of flying without
            going up… or down too quickly. No feeling of falling or fear of
            heights. And once you’re fully enjoying the flight, you’ll even have
            the chance to fly the paraglider yourself and/or discover some
            acrobatic figures.
          </p>
          <h3>What’s included?</h3>
          <p>
            Fees for takeoff and landing, insurance, and transportation to the
            takeoff site. Plus, complimentary full video and pictures of your
            flight sent directly to your mobile phone in less than 5 minutes, no
            internet required.
          </p>
        </div>
        <img src={img4} alt="" />
      </div>
    </div>
  );
};

export default Flights1;
